import Call from '../Call.v2';

const CalendarEvents = {
    get() {
        return Call(`calendar/events/`);
    },

    save(event) {
        return Call(`calendar/events`, 'POST', event);
    },

    update(id, event) {
        return Call(`calendar/events/${id}`, 'PUT', event);
    },

    remove(id) {
        return Call(`calendar/events/${id}`, 'DELETE');
    },
};

export default CalendarEvents;


// WEBPACK FOOTER //
// ./src/services/API/components/CalendarEvents.js